export default IconFreezeRowColumn => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-freeze-row-column" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z" />
  <path d="M15 3l-12 12" />
  <path d="M9.5 3l-6 6" />
  <path d="M20 3.5l-5.5 5.5" />
  <path d="M9 15l-5 5" />
  <path d="M21 9h-12v12" />
</svg>`;